module.exports = __webpack_public_path__ + "img/官网-V1_10.a1fe7c10.png";